<!-- 产业服务-仓配一体化服务 -->
<template>
<div class="info-block">
  <a class="info-block-a">
    <div class="div-1" v-bind:style="{backgroundImage:'url('+info.cover_img+')'}">
      <div class="div-1-4">
        <table class="div-1-4-table" cellpadding="0" cellspacing="0" border="0px">
          <tr>
            <td class="td-title">B2B服务</td>
            <td class="td-title">B2C服务</td>
            <td class="td-title">可租面积</td>
            <td class="td-title">起租面积</td>
          </tr>
          <tr>
            <td class="td-value price">￥{{info.price}}<span>起/单</span></td>
            <td class="td-value price">￥{{info.price}}<span>起/单</span></td>
            <td class="td-value">{{info.able_area}}</td>
            <td class="td-value">{{info.start_area}}</td>
          </tr>
        </table>
      </div>
      <div class="div-3">
        <router-link :to="{path: '/sggqDetail'}" class="td-action-1">
        业务咨询
        </router-link>
      </div>
    </div>
  </a>
</div>
</template>

<script>
export default {
  name: 'CyfwInfo5',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:130px;
  padding:0px;
  margin:0px 1px 10px 0px;
  //background-color: #F6F8F9;
  border-bottom:1px dashed #ddd;

  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
//border-bottom:1px solid var(--color6);
//box-shadow:0px 0px 1px 0px #eee;
}

.div-1{
  position:relative;
  height:120px;
  width:100%;
  padding:0px 0px 0px 230px;
  background:#green;
  background-size: 220px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.div-1-4{
  position:relative;
  height:120px;
  //background:green;
  text-align:left;
  color:#888;
  padding:30px 120px 0px 0px;
}

.div-1-4-table{
  width:100%;
}

.div-1-4-table .td-title{
  text-align:left;
  width:140px;
  height:30px;
  line-height:20px;
  color:#888;
  border-left:1px solid #ddd;
  padding-left:10px;
}

.div-1-4-table .td-title:first-child{
  border-left:0px solid #ddd;
}

.div-1-4-table .td-value{
  text-align:left;
  width:140px;
  height:30px;
  font-size:14px;
  line-height:20px;
  color:var(--color2);
  border-left:1px solid #ddd;
  padding-left:10px;
}

.div-1-4-table .td-value:first-child{
  border-left:0px solid #ddd;
}

.div-1-4-table .address{
  font-size:14px;
}

.div-1-4-table .price{
  font-weight:600;
  color:red;
}

.div-3{
  position:absolute;
  top:0px;
  right:0px;
  width:120px;
  margin:0px;
  //background:green;
}

.div-3 .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 10px 5px 10px;
  margin:40px auto;
  border:1px solid var(--color7);
  color:#888;
  line-height:20px;
  text-align:center;
  //background:yellow;
}

.div-3 .td-action-1:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}

.div-3 .td-action-2{
  display:block;
  width:160px;
  padding:0px;
  margin:0px;
  color:#888;
  line-height:20px;
  text-align:center;
  //background:yellow;
}

</style>



// WEBPACK FOOTER //
// src/components/module/CyfwInfo5.vue